// Friend List
NP.Friend = (function( $ ) {

	// layer outline 생성
	var layer = $(NP.template.withFriendLayer()).appendTo( 'body' );

	NP.body.on( 'click', '#flyoutMProfile .count a, .list_friends dd.together .count a, .wrap_listFriend h5 a[data-np], #rightAside .connect a[data-np]', function() {
		var elData = $( this ).data( 'np' );

		$.ajax({
			type : 'get',
			url : NP.prflUri( NP.dt.v ) + '/my/friend/' + elData.id + '/list/withfriend.jsonp',
			dataType : 'jsonp',
			success : function( data ) {
				if ( data.result ) {
					// 닉네임 전달
					var nickname = (elData.nm.length <= 6) ? elData.nm : elData.nm.substring(0, 6) + '...';

					layer.find( '.wrap_together' ).html(
						NP.template.withFriendLayerCont({
							userName : nickname,
							withFriend : data.result
						})
					);

					modalless.show( layer );
				}
			}
		});

		return false;
	});
}( jQuery ));
